'use client';

import type { FC } from 'react';
import { ItemCard } from '../../components/ItemCard';
import { cn } from '../../utils/cn';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { ItemPrice } from '../../components/ItemPrice';
import { List, Cell } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import translations from './ContractScreen.translations';
import type { ContractOutputItem } from '../../services/generated/Api';

interface ContractSuccessResultProps {
  outputItem: ContractOutputItem;
}

export const ContractSuccessResult: FC<ContractSuccessResultProps> = ({ outputItem }) => {
  const isDesktop = useIsDesktop();
  const { t } = useLocalTranslation(translations);
  return (
    <div className={cn('flex flex-col gap-4 [animation:upgradeFadeInScale_0.6s_ease-out_both] [animation-delay:0.2s] opacity-0', !isDesktop && 'px-4 pt-3')}>
      <ItemCard
        imageUrl={outputItem.imageUrl}
        name={outputItem.name}
        rarity={outputItem.rarityName}
        rarityColor={outputItem.rarityColor}
      />
      <List>
        <Cell
          after={
            <ItemPrice credits={outputItem.value} steamPrice={outputItem.steamPrice} creditsIconSize={16} className="gap-1.5" />
          }
          isLast
        >
          {t('price')}
        </Cell>
      </List>
    </div>
  );
};
